<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1"/>

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/atencion">Atenciones</router-link> >
            <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link>
            > Referencias - Derivaciones
          </div>
        </div>
        <div class="col-1">
<button
  class="btn-help"
  type="button"
  title="Abrir ayuda"
  @click="showModalHelp = true"
  aria-label="Abrir ayuda de referencias y derivaciones"
>
  <span class="material-symbols-outlined">help</span>
</button>
        </div>
      </div>
    </div>
<Modal v-model:modelValue="showModalHelp" title="Ayuda — Referencias / Derivaciones">
  <AyudaAtencionReferencia />
</Modal>
    <hr>

    <!-- Info Atención -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-1"><label class="form-label">Paciente</label></div>
                <div class="col-5">
                  <input type="text" class="form-control" v-model="datoAtencion.nombrePaciente" disabled>
                </div>
                <div class="col-1"><label class="form-label">Cédula</label></div>
                <div class="col-2">
                  <input type="text" class="form-control" v-model="datoAtencion.documentoPaciente" disabled>
                </div>
                <div class="col-1"><label class="form-label">Tipo</label></div>
                <div class="col-2">
                  <select class="form-select" v-model="datoAtencion.tipo" disabled>
                    <option value="I">Inicial</option>
                    <option value="S">Subsecuente</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1"><label class="form-label">Médico</label></div>
                <div class="col-5">
                  <input type="text" class="form-control" v-model="datoAtencion.nombreMedico" disabled>
                </div>
                <div class="col-1"><label class="form-label">Especial.</label></div>
                <div class="col-5">
                  <input type="text" class="form-control" v-model="datoAtencion.nombreEspecialidad" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1"><label class="form-label">Motivo</label></div>
                <div class="col-5">
                  <textarea class="form-control" v-model="datoAtencion.motivo" style="text-transform:uppercase" disabled></textarea>
                </div>
                <div class="col-1"><label class="form-label">Obs.</label></div>
                <div class="col-5">
                  <textarea class="form-control" v-model="datoAtencion.observacion" style="text-transform:uppercase" disabled></textarea>
                </div>
              </div>
            </div>
            <button @click.prevent="mostrarOcultarBloque">
              {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
            </button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label class="form-label">Id. Atención</label>
                  <input type="text" class="form-control" v-model="datoAtencion.idAtencion" disabled>
                </div>
                <div class="col-5">
                  <label class="form-label">Fecha de Registro</label>
                  <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaReg)" disabled>
                </div>
                <div class="col-5">
                  <label class="form-label">Fecha de Actualización</label>
                  <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaAct)" disabled>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!--  DataTable de Referencias  -->
    <DataTable
      :data="referencias"
      :columns="columnasReferencia"
      idField="idReferencia"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="estadoPermitido"
      :mostrarBotonExcel="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="estadoPermitido"
      mensajeVacio="No hay referencias registradas."
      @refresh="getDataTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idReferencia)"
      @view="row => abrirEditarDet(row.idReferencia)"
      @delete="row => deleteReferencia(row.idReferencia)"
    >
      <!-- Slot para botón extra: Formulario PDF -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-secondary"
          @click="formulario053_PDF(row.idReferencia)"
          title="Formulario informe"
        >
          <span class="material-icons" style="font-size:14px">picture_as_pdf</span>
        </button>
      </template>
    </DataTable>

    <!-- Modal Referencia -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title">{{ titulo }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">

              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-2"><label class="form-label">IdReferencia</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoReferencia.idReferencia" disabled>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Motivo Ref./Der.</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.idMotivoRef" :disabled="!estadoPermitido">
                      <option v-for="m in motivoRefs" :value="m.idMotivoRef" :key="m.idMotivoRef">{{ m.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Destino</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.idEmpresaDestino" :disabled="!estadoPermitido" @change="fetchMedicos()">
                      <option v-for="e in empresaDestinos" :value="e.idEmpresaDestino" :key="e.idEmpresaDestino">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Especialidad</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.idEspecialidad" :disabled="!estadoPermitido">
                      <option v-for="e in especialidades" :value="e.idEspecialidad" :key="e.idEspecialidad">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Médico</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.idMedico" :disabled="!estadoPermitido">
                      <option v-for="m in medicos" :value="m.idMedico" :key="m.idMedico">
                        {{ m.nombreCompleto }} - {{ m.especialidadNombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Fecha Ref./Der.</label></div>
                  <div class="col-4">
                    <input type="date" class="form-control" v-model="datoReferencia.fechaRef" required :disabled="!estadoPermitido">
                  </div>
                  <div class="col-2"><label class="form-label">Hora</label></div>
                  <div class="col-4">
                    <input type="time" class="form-control" v-model="datoReferencia.hora" required :disabled="!estadoPermitido">
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Tipo</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.tipo" :disabled="!estadoPermitido">
                      <option value="R">R: Referencia</option>
                      <option value="D">D: Derivación</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Textareas con dictado -->
              <div class="mb-3" v-for="campo in camposDictado" :key="campo.field">
                <div class="row">
                  <div class="col-2"><label class="form-label">{{ campo.label }}</label></div>
                  <div class="col-10">
                    <div class="textarea-container-mic">
                      <textarea class="form-control" v-model="datoReferencia[campo.field]" style="text-transform:uppercase" :disabled="!estadoPermitido"></textarea>
                      <div class="buttons-container-mic">
                        <button v-if="!campo.isDictating" @click="startDictation(campo)" type="button" class="btn btn-light" title="Iniciar Dictado">
                          <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                        </button>
                        <button v-else @click="stopDictation(campo)" type="button" class="btn btn-light" title="Finalizar Dictado">
                          <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Justificada</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoReferencia.justificada" required :disabled="!estadoPermitido">
                      <option value="S">Sí</option>
                      <option value="N">No</option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button class="btn btn-success" @click.prevent="guardarReferencia" v-if="btnCrear_det">
              <span class="material-symbols-outlined align-middle" style="font-size:32px;">save</span> Guardar
            </button>
            <button class="btn btn-success" @click.prevent="guardarEditReferencia" v-if="btnEditar_det && estadoPermitido">
              <span class="material-symbols-outlined align-middle" style="font-size:32px;">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import { openModal, closeModal } from '@/modules/modalHelper.js'
//import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import SpeechDictation from '@/modules/microfono.js';
import AyudaAtencionReferencia from '@/views/ayuda/AyudaAtencionReferencia.vue'
import api from "@/services/api";
import config          from '@/config.js'
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'

export default {
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_numero:         { type: String, required: true },
  },
  components: { Layout, Footer, DataTable, AyudaAtencionReferencia },
  data() {
    return {
      // Master
      datoAtencion: {},
      mostrarBloque: false,
      showModalHelp: false,
      // Detail
      referencias: [],
      datoReferencia: {},
      titulo: '',
      btnCrear_det: false,
      btnEditar_det: false,
      modalWindow: true,
      motivoRefs: [],
      empresaDestinos: [],
      especialidades: [],
      medicos: [],
      dictation: new SpeechDictation(),
      // Columnas del DataTable
      columnasReferencia: [
        {
          field: 'fechaRef',
          label: 'Fecha Ref.',
          format: (val) => dateFormat.getFormattedDate(val),
        },
        { field: 'hora',   label: 'Hora' },
        { field: 'tipo',   label: 'Tipo' },
        { field: 'motivo', label: 'Motivo' },
      ],
      // Campos de dictado (evita repetir 4 bloques idénticos)
      camposDictado: [
        { field: 'motivo',      label: 'Motivo',      isDictating: false },
        { field: 'resumen',     label: 'Resumen',     isDictating: false },
        { field: 'hallazgos',   label: 'Hallazgos',   isDictating: false },
        { field: 'tratamiento', label: 'Tratamiento', isDictating: false },
      ],
    };
  },
  
  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },
  
  mounted() {
    this.abrirEditar(this.p_idAtencion);
    this.getDataTodos();
    this.fetchMotivoRefs();
    this.fetchEmpresaDestinos();
    this.fetchEspecialidades();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    //  Master
    abrirEditar(idAtencion) {
      if (idAtencion) {
        api.get('/vwatencions/' + idAtencion).then(resp => {
          this.datoAtencion = resp.data;
        });
      }
    },
    //  Detail
    getDataTodos() {
      api.get('/vwreferencias/idatencion/' + this.p_idAtencion).then(response => {
        this.referencias = response.data.reverse();
      });
    },
    abrirModalCrear() {
      this.modalWindow    = true;
      this.datoReferencia = {};
      this.titulo         = 'Registro de Referencias - Derivaciones';
      this.btnCrear_det   = true;
      this.btnEditar_det  = false;
      openModal('ventanaModal');
    },
    abrirModalEditar(idReferencia) {
      this.modalWindow   = true;
      this.titulo        = 'Editar Referencia - Derivación';
      this.btnCrear_det  = false;
      this.btnEditar_det = true;
      if (idReferencia) {
        api.get('/vwreferencias/' + idReferencia).then(resp => {
          this.datoReferencia = resp.data;
        });
      }
      openModal('ventanaModal');
    },
    abrirEditarDet(idReferencia) {
      if (idReferencia) {
        this.$router.push(`/referenciaform/${this.p_idAtencion}/${this.p_numero}/${idReferencia}/${this.p_estadoAtencion}/A`)
      }
    },
    async guardarReferencia() {
      try {
        this.datoReferencia.idEmpresaOrigen = window.sessionStorage.getItem("idEmpresa");
        this.datoReferencia.idAtencion      = this.datoAtencion.idAtencion;
        this.datoReferencia.idPersona       = this.datoAtencion.idPersona;
        await api.post('/referencias', this.datoReferencia);
        closeModal('ventanaModal');
        swal("Correcto!", "Referencia creada exitosamente!", "success");
        this.getDataTodos();
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error");
      }
    },
    async guardarEditReferencia() {
      try {
        await api.post('/referencias', this.datoReferencia);
        closeModal('ventanaModal');
        swal("Correcto!", "Referencia actualizada exitosamente!", "success");
        this.getDataTodos();
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error");
      }
    },
    async deleteReferencia(idReferencia) {
      const ok = await swal({ title: "¿Eliminar?", icon: "warning", buttons: true, dangerMode: true });
      if (!ok) return;
      try {
        await api.delete('/referencias/' + idReferencia);
        this.getDataTodos();
      } catch {
        swal("Error!", "No se pudo eliminar.", "error");
      }
    },
    formulario053_PDF(idReferencia) {
      window.open(`${config.apiReportesUrl}/7/${idReferencia}`, '_blank');
    },
    //  Catálogos
    fetchMotivoRefs() {
      api.get('/vwmotivorefs').then(r => { this.motivoRefs = r.data; });
    },
    fetchEmpresaDestinos() {
      api.get('/vwempresas').then(r => { this.empresaDestinos = r.data; });
    },
    fetchMedicos() {
      api.get('/vwmedicos/idempresa/' + this.datoReferencia.idEmpresaDestino)
        .then(r => { this.medicos = r.data; });
    },
    fetchEspecialidades() {
      api.get('/vwespecialidads').then(r => { this.especialidades = r.data; });
    },
    //  Dictado (unificado)
    startDictation(campo) {
      campo.isDictating = true;
      this.dictation.startDictation((transcript) => {
        this.datoReferencia[campo.field] = transcript;
      }, this.datoReferencia[campo.field]);
    },
    stopDictation(campo) {
      campo.isDictating = false;
      this.dictation.stopDictation();
    },
  },
};
</script>

<style src="@/assets/css/microfono.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>